import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DecimalPipe} from '@angular/common';

@Component({
    selector: 'app-betriebskostenspiegel',
    templateUrl: './betriebskostenspiegel.component.html',
    standalone: false
})
export class BetriebskostenspiegelComponent implements OnInit {
  /**
   * current building is on stage
   */
  @Input() value: number;

  /**
   * minimum value
   */
  @Input() min: number;

  /**
   * maximum value
   */
  @Input() max: number;

  /**
   * Switch or showing apartement building vs. single family home
   */
  @Input() isApartementBuilding = true;

  /**
   * Prefix for all used textkeys
   */
  @Input() textKeyPrefix = 'bekocheck.ergebnis.condition';

  /**
   * toggle for the average building
   */
  @Input() showAverage = true;

  /**
   * Eventemitter that is called if the stage is set. Stage can be a number from 0 to 2
   */
  @Output() stageSet: EventEmitter<number> = new EventEmitter<number>();

  /**
   * The DOM element where the build is placed in
   */
  @ViewChild('building') buildingWrapper: ElementRef;

  /**
   * current visible stage
   */
  stage: number;

  /**
   * The several stages where this building could be placed
   */
  stages: string[] = [];

  /**
   * toggle if a text is available (textkey filled)
   */
  hasHint = false;

  /**
   * constructor
   */
  constructor(private translate: TranslateService, private decimalPipe: DecimalPipe) {
  }

  /**
   * Initialize the stages we want to show and the current active stage
   */
  ngOnInit(): void {
    this.stages.push('<' + this.decimalPipe.transform(this.min, '1.2-2'));
    this.stages.push(this.decimalPipe.transform(this.min, '1.2-2') + '-' + this.decimalPipe.transform(this.max, '1.2-2'));
    this.stages.push('>' + this.decimalPipe.transform(this.max, '1.2-2'));

    if (this.value < this.min) {
      this.stage = 0;
    }
    else if (this.value > this.max) {
      this.stage = 2;
    }
    else {
      this.stage = 1;
    }

    // emit event that the stage is set
    this.stageSet.emit(this.stage);

    // check if we have a hint text
    const hintTextkey = this.textKeyPrefix + '.yourbuilding.hint';
    this.translate.get(hintTextkey).subscribe(data => {
      this.hasHint = data && data !== hintTextkey;
    });
  }

}
